import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.reduce";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var VelocityTracker = function () {
  function VelocityTracker() {
    _classCallCheck(this, VelocityTracker);

    this.history = [];
    this.lastPosition = undefined;
    this.lastTimestamp = undefined;
  }

  _createClass(VelocityTracker, [{
    key: "add",
    value: function add(position) {
      var timestamp = new Date().valueOf();

      if (this.lastPosition && timestamp > this.lastTimestamp) {
        var diff = position - this.lastPosition;

        if (diff > 0.001 || diff < -0.001) {
          this.history.push(diff / (timestamp - this.lastTimestamp));
        }
      }

      this.lastPosition = position;
      this.lastTimestamp = timestamp;
    }
  }, {
    key: "estimateSpeed",
    value: function estimateSpeed() {
      var finalTrend = this.history.slice(-3);
      var sum = finalTrend.reduce(function (r, v) {
        return r + v;
      }, 0);
      return sum / finalTrend.length;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.history = [];
      this.lastPosition = undefined;
      this.lastTimestamp = undefined;
    }
  }]);

  return VelocityTracker;
}();

if (typeof VelocityTracker !== 'undefined' && VelocityTracker && VelocityTracker === Object(VelocityTracker) && Object.isExtensible(VelocityTracker) && !VelocityTracker.hasOwnProperty('__filemeta')) {
  Object.defineProperty(VelocityTracker, '__filemeta', {
    configurable: true,
    value: {
      name: "VelocityTracker",
      filename: "node_modules/react-native-calendars/src/input.js"
    }
  });
}